// -----------------------------------------------------------------------------
// PLUGINS/MEDIA
// -----------------------------------------------------------------------------
import { NodeSelection } from "prosemirror-state";
// -----------------------------------------------------------------------------
import icons from "../util/icons";
import { elt, input, setClass, calcModulePosition_ } from "../util/dom";
export class Media {
    constructor(editor, container, nodetype, key, id, app) {
        this.editor = editor;
        this.id = id;
        this.key = key;
        this.miniName = "image-mini";
        this.panelName = "image-panel";
        this.nodetype = nodetype;
        this.node = null;
        this.app = app;
        this.focused = true;
        this.container = container;
        this.dom = elt("div", {
            className: "df-ed-mu__item df-ed-mu__item--clickable",
            onclick: () => { this.openModal(); }
        }, icons.photo("df-ed-mu__icon"));
        // The mini panel
        this.miniPointer =
            icons.pointer("df-ed-mi__pointer");
        this.mini = elt("div", {
            className: "df-ed-mi"
        }, this.miniPointer, elt("div", {
            className: "df-ed-mi__container"
        }, elt("div", {
            className: "df-ed-mi__button df-ed-mi__button--open",
            onclick: () => { this.openPanel(); }
        }, icons.edit("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button df-ed-mi__button--remove",
            onclick: () => { this.remove(); }
        }, icons.circleX("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button df-ed-mi__button--remove",
            onclick: () => { this.editPic(); }
        }, icons.artboard("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button",
            onclick: () => { this.setWrap(true); }
        }, icons.wrap("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button",
            onclick: () => { this.setWrap(false); }
        }, icons.nowrap("df-ed-mi__icon"))));
        editor.dom.parentNode.insertBefore(this.mini, editor.dom);
        //
        this.title =
            input("text", "df-ed-pp__field", "Image Title");
        this.alt =
            input("text", "df-ed-pp__field", "Alt Text");
        this.panelPointer =
            icons.pointer("df-ed-pp__pointer");
        this.panel = elt("div", {
            className: "df-ed-pp"
        }, this.panelPointer, elt("div", {
            className: "df-ed-pp__container"
        }, elt("div", {
            className: "df-ed-pp__fields"
        }, elt("div", {
            className: "df-ed-pp__row"
        }, elt("label", {
            className: "df-ed-pp__fieldgroup"
        }, elt("span", { className: "df-ed-pp__label" }, "TITLE"), this.title)), elt("div", {
            className: "df-ed-pp__row"
        }, elt("label", {
            className: "df-ed-pp__fieldgroup"
        }, elt("span", { className: "df-ed-pp__label" }, "ALT"), this.alt))), elt("div", {
            className: "df-ed-pp__buttons df-ed-pp__buttons--fig"
        }, elt("div", {
            className: "df-ed-pp__button",
            onclick: () => { this.updateImage(); }
        }, icons.arrowsRight("df-ed-pp__icon")), elt("div", {
            className: "df-ed-pp__button",
            onclick: () => { this.remove(); }
        }, icons.x("df-ed-pp__icon")))));
        editor.dom.parentNode.insertBefore(this.panel, editor.dom);
        // General events
        window.addEventListener("mousedown", (event) => {
            let active = this.key.getState(this.editor.state).module;
            let target = event.target;
            if (target instanceof Element) {
                if (!this.panel.contains(target)) {
                    this.focused = false;
                    if (active === this.panelName)
                        this.closeModules();
                }
                else {
                    this.focused = true;
                }
                if (!this.mini.contains(target) && !this.editor.dom.contains(target)) {
                    this.focused = false;
                    if (active === this.miniName)
                        this.closeModules();
                }
                else {
                    this.focused = true;
                }
            }
        });
        window.addEventListener("keydown", (event) => {
            let active = this.key.getState(this.editor.state).module;
            if (active === this.panelName) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    this.updateImage();
                }
                if (event.key === "Escape") {
                    event.preventDefault();
                    this.closeModules();
                }
            }
        });
        window.addEventListener("resize", () => {
            let active = this.key.getState(this.editor.state).module;
            if (active === this.miniName)
                this.positionMini();
            if (active === this.panelName)
                this.positionPopup();
        });
    }
    editPic() {
        if (this.app && this.node.phase === "viewing") {
            this.app.ports.openMedia.send({ id: this.id, pic: this.node.content.attrs.id, picker: null });
        }
    }
    setWrap(wrap) {
        if (this.app && this.node.phase === "viewing") {
            let tr = this.editor.state.tr;
            tr.setNodeAttribute(this.node.pos, "wrap", wrap);
            this.editor.dispatch(tr);
        }
    }
    remove() {
        if (this.node.phase === "editing" || this.node.phase === "viewing") {
            this.editor.dispatch(this.editor.state.tr.deleteSelection());
        }
        this.closeModules();
    }
    updateImage() {
        if (this.node.phase === "editing") {
            let attrs = Object.assign(this.node.content.attrs, {
                title: this.title.value,
                alt: this.alt.value,
            });
            let tr = this.editor.state.tr;
            tr.setNodeMarkup(this.node.pos, this.nodetype, attrs);
            this.editor.dispatch(tr);
            this.closeModules();
        }
    }
    openMini(node, selection) {
        this.node = { phase: "viewing", pos: selection.from, content: node };
        let tr = this.editor.state.tr;
        tr.setMeta(this.key, this.miniName);
        this.editor.dispatch(tr);
    }
    openPanel() {
        let tr = this.editor.state.tr;
        let selection = this.editor.state.selection;
        if (selection instanceof NodeSelection) {
            if (selection.node.type === this.nodetype) {
                this.title.value = selection.node.attrs.title || "";
                this.alt.value = selection.node.attrs.alt || "";
                this.node = { phase: "editing", pos: selection.from, content: selection.node };
                tr.setMeta(this.key, this.panelName);
                tr.scrollIntoView();
                this.editor.dispatch(tr);
            }
        }
    }
    closeModules() {
        let tr = this.editor.state.tr;
        this.node = null;
        this.editor.dispatch(tr.setMeta(this.key, "close-module"));
        this.editor.focus();
    }
    openModal() {
        if (this.app)
            this.app.ports.openMedia.send({ id: this.id, pic: null });
    }
    positionMini() {
        let { from, to } = this.editor.state.selection;
        let { x, y } = calcModulePosition_(this.editor, this.container.panel, from, to, this.mini.getBoundingClientRect().width / 2);
        this.mini.style.top = y;
        this.mini.style.marginLeft = x;
    }
    positionPopup() {
        let { from, to } = this.editor.state.selection;
        let { x, y } = calcModulePosition_(this.editor, this.container.panel, from, to, 15);
        this.panel.style.top = y;
        this.panelPointer.style.left = x;
    }
    update() {
        let selection = this.editor.state.selection, active = this.key.getState(this.editor.state).module, anyActive = active === this.panelName || active === this.miniName;
        setClass(this.mini, "df-ed-mi--active", active === this.miniName);
        setClass(this.panel, "df-ed-pp--active", active === this.panelName);
        if (!active &&
            selection instanceof NodeSelection &&
            selection.node.type === this.nodetype &&
            this.focused) {
            this.openMini(selection.node, selection);
            return;
        }
        let locationChanged = !(selection instanceof NodeSelection) || (selection.node &&
            this.node &&
            this.node.content &&
            !selection.node.eq(this.node.content));
        if (anyActive && locationChanged &&
            (this.node.phase === "editing" || this.node.phase === "viewing")) {
            this.closeModules();
            return;
        }
        if (active === this.panelName)
            this.positionPopup();
        if (active === this.miniName)
            this.positionMini();
    }
    active() {
        return this.node !== null;
    }
    destroy() {
        this.mini.remove();
        this.panel.remove();
    }
}
export function insertImage(editor, image) {
    let tr = editor.state.tr;
    let attrs = {
        src: image.source,
        id: image.pic,
        size: image.size,
        title: image.title,
        alt: "",
        width: image.width,
        height: image.height,
    };
    tr.replaceSelectionWith(editor.state.schema.nodes.image.create(attrs));
    editor.dispatch(tr);
}
